import { render } from "./PaywallVariantB.vue?vue&type=template&id=059ad237&scoped=true"
import script from "./PaywallVariantB.vue?vue&type=script&lang=js"
export * from "./PaywallVariantB.vue?vue&type=script&lang=js"

import "./PaywallVariantB.vue?vue&type=style&index=0&id=059ad237&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059ad237"]])

export default __exports__